import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_TASK_TEMPLATE_REFERENCE_DATA =
  "GET_TASK_TEMPLATE_REFERENCE_DATA";

export const service = async (data) => {
  const options: object = {
    url: `/Api/RefTask/GetReferenceData`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TASK_TEMPLATE_REFERENCE_DATA, service, mock);
